<template>
  <div class="atom-loader">
    <div class="dot" />
    <div class="dot" />
    <div class="dot" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
